import { useGetIntegrationMcpTokens } from 'api';

import { useOrganisationId } from 'hooks/context';

export const useMcpTokens = () => {
  const organisationId = useOrganisationId<number>();
  // gcTime: 0 drops MCP token metadata from the query cache as soon as it is
  // unobserved — mitigation for stale org-switch flags and cache-after-logout
  // (PEGO-13911 review F15/F18).
  const { data, isLoading, isError } = useGetIntegrationMcpTokens(
    organisationId,
    { query: { gcTime: 0 } }
  );

  return { tokens: data?.data ?? [], isLoading, isError };
};
